/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Meeting_Prep_Action_DoneInputs */



/**
* | output |
* | --- |
* | "Tick off: {text}" |
*
* @param {Meeting_Prep_Action_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_action_done = /** @type {((inputs: Meeting_Prep_Action_DoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Action_DoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Afvinken: ${i?.text}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cocher : ${i?.text}`)
	return /** @type {LocalizedString} */ (`Tick off: ${i?.text}`)
});